export default __webpack_public_path__ + "static/media/pag8.c3bf7092.jpg";